export default __webpack_public_path__ + "static/media/genCRM.ee3fc407.jpg";